export const FETCH_NEW_USER_CASES = 'FETCH_NEW_USER_CASES';
export const FETCH_NEW_USER_CASES_START = 'FETCH_NEW_USER_CASES_START';
export const FETCH_NEW_USER_CASES_SUCCESS = 'FETCH_NEW_USER_CASES_SUCCESS';
export const FETCH_NEW_USER_CASES_ERROR = 'FETCH_NEW_USER_CASES_ERROR';
export const NEW_CASES_PAGINATION = 'NEW_CASES_PAGINATION';

export const ADD_USER_CASE_TO_MY_LIBRARY = '[NEW_CASES] ADD_USER_CASE_TO_MY_LIBRARY';
export const ADD_USER_CASE_TO_MY_LIBRARY_SUCCESS = '[NEW_CASES] ADD_USER_CASE_TO_MY_LIBRARY_SUCCESS';
export const ADD_USER_CASE_TO_MY_LIBRARY_ERROR = '[NEW_CASES] ADD_USER_CASE_TO_MY_LIBRARY_ERROR';

export const fetchNewUserCases = () => {

    return {
        type: FETCH_NEW_USER_CASES
    };
};

export const addNewCaseToMyLibrary = (payload) => {
    return {
        type: ADD_USER_CASE_TO_MY_LIBRARY,
        payload
    };
}


